"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeManager = void 0;
var shapes = new Map();

var ShapeManager = /*#__PURE__*/function () {
  function ShapeManager() {
    _classCallCheck(this, ShapeManager);
  }

  _createClass(ShapeManager, null, [{
    key: "addShape",
    value: function addShape(name, drawer) {
      if (!ShapeManager.getShape(name)) {
        shapes.set(name, drawer);
      }
    }
  }, {
    key: "getShape",
    value: function getShape(name) {
      return shapes.get(name);
    }
  }, {
    key: "getSupportedShapes",
    value: function getSupportedShapes() {
      return shapes.keys();
    }
  }]);

  return ShapeManager;
}();

exports.ShapeManager = ShapeManager;